<template>
  <main></main>
</template>

<script>
export default {
  name: "HowWork"
};
</script>

<style></style>
